import { Component, OnInit, ViewChild, Input, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService} from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { AnnouncementManagementService } from '../services/announcement-management.service';
import { UpdatePinComponent } from '../shared/update-pin/update-pin.component';
import { WitnessAuthenticationComponent } from '../shared/witness-authentication/witness-authentication.component';
import { OktaAuthStateService } from '@okta/okta-angular';
import { filter, take, takeUntil } from 'rxjs/operators';
import { ROUTE_PATHS } from '../route-paths';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})

export class HomeComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  authService = inject(AuthService);
  private messageService = inject(MessageService);
  private announcementManagementService = inject(AnnouncementManagementService);
  private oktaAuthStateService = inject(OktaAuthStateService);

  readonly routePaths = ROUTE_PATHS;
  
  @ViewChild('witnessAuthDialog') witnessAuthDialog!: WitnessAuthenticationComponent;
  @ViewChild('updatePinDialog') updatePinDialog!: UpdatePinComponent;


 
  validationProgressDialog = false;
  cols: any[] = [];
  isHome = true;
  fullName = '';
  @Input() failed = false;
  @Input() deId = false;
  skinPath = environment.assets;
  versionType = environment.userAuthVersion
  enableAssayManagement = environment.enableAssayManagement;
  enableItemsOfInterest = environment.enableItemsOfInterest;
  enabledStockAreaConfig = environment.enabledStockAreaConfig;
  enableConfigurationManagement = environment.enableConfigurationManagement;
  enableNotificationManagement = environment.enableNotificationManagement;
  disableWitnessAuth = environment.disableWitnessAuth;
  logoPath = "/assets/images/all_logos/" + environment.logoFile;
  userTries = 0;
  dissableDeIdSwitch = false;
  showHeader = false;
  private readonly destroy$ = new Subject<void>();
  activeAnnouncementCount = 0;

  ngOnInit(): void {
    const deIdState = this.authService.getDeIdState();
    this.deId = deIdState.value;
    this.dissableDeIdSwitch = deIdState.disabled;

    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (this.authService.isDemoUser()) {
        this.deId = true;
        this.dissableDeIdSwitch = true;
        return;
      }

      if (typeof data['deId'] === 'boolean') {
        this.deId = data['deId'];
        this.authService.setDeIdentified(this.deId);
      }
    });

    this.authService.userAuthFailed.pipe(takeUntil(this.destroy$)).subscribe((failed: boolean) => {
        if (failed) {
          this.failed = true;
        }
      });
    const body = document.getElementsByTagName('body')[0];
    body.className = "";
    body.classList.add('home');

    if (this.authService.hasLocalSession()) {
      if (this.authService.user) {
        this.initializeAfterUser();
      } else {
        void this.authService.initializeLocalSession().then((authenticated) => {
          if (authenticated) {
            this.initializeAfterUser();
          }
        });
      }
      return;
    }

    // Wait for Okta auth state to confirm authentication before making API calls
    this.oktaAuthStateService.authState$.pipe(
      filter(authState => !!authState.isAuthenticated),
      take(1),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if(!this.authService.user) {
        this.authService.userInitialized.pipe(
          takeUntil(this.destroy$),
          filter(initialized => initialized),
          take(1)
        ).subscribe(() => {
          this.initializeAfterUser();
        });
        this.authService.getSetLocalUserAccount();
      } else {
        this.initializeAfterUser();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeAfterUser() {
    if (this.authService.isDemoUser()) {
      this.deId = true;
      this.dissableDeIdSwitch = true;
    }
    this.showHeader = true;
    if (this.canViewAnnouncementManagement()) {
      this.announcementManagementService.getAnnouncements(0, 1, 'active').pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: (response) => this.activeAnnouncementCount = response.activeCount ?? response.count,
        error: () => this.activeAnnouncementCount = 0,
      });
    }
  }

  navigateTo(){
    this.router.navigateByUrl('/select-source');
  }

  authenticateWitness(){
    if (this.disableWitnessAuth) {
      this.authService.loginAuthorizedWitness().subscribe({
        next: (result) => {
          this.authService.setWitnesToken(result);
          this.router.navigate(['/' + ROUTE_PATHS.assayManagement + '/' + this.deId.toString()]);
        },
        error: () => {
          if (this.witnessAuthDialog) {
            this.witnessAuthDialog.showDialog = false;
          }
          this.messageService.add({
            key: 'session',
            severity: 'error',
            summary: 'Unable to access Assay Management',
            detail: 'Please try again or contact support.',
            life: 4000
          });
        }
      });
    } else {
      if (this.witnessAuthDialog) {
        this.witnessAuthDialog.showDialog = true;
      }
    }
  }

  /**  */

  /** MP-176 */
  validationProgress(url: string){
    if(environment.environment == "mayo-prod") {
      this.router.navigateByUrl(url);
    }
    else{
      this.validationProgressDialog=true
    }

  }

  //** MP_176 */ 

  getInsightLink(){
    
    return "/visualization/maap-analytics";
    
    // if(environment.environment == "mayo-prod") {
    //   return null;
    // }
    // else{
    //   return "/visualization/maap-analytics";
    // }
  }

  getP2pLink(){
    return "/peer-to-peer/" + this.deId.toString();
    
    // if(environment.environment == "mayo-prod") {
    //   return null;
    // }
    // else{
    //   return "/peer-to-peer";
    // }
  }

  getToolTip(){
    if(environment.environment == "mayo-prod") {
      return "Validation in Progress";
    }
    else{
      return "";
    }
  }

  isP2PVisible(){
    if(environment.environment == "mayo-prod") {
      return false;
    }
    else{
      return true;
    }
  }


  showPincodeUpdateModal(){
    if (this.witnessAuthDialog) {
      this.witnessAuthDialog.showDialog = false
    }
    if (this.updatePinDialog) {
      this.updatePinDialog.showDialog = true
    }
  }

  showToast(status: any){
    if(status == "SUCCESS"){
      this.messageService.add({
        severity: 'success',
        summary: 'Updated successfully',
        detail: 'Your pincode has been updated successfully.'
      });
    }
    else if(status == "FAILURE"){
      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Pincode update failed.'
      });
    }
    else if(status == "PREVIOUSPINCODEMATCH"){
      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Please use different pincode than previously used.'
      });
    }
  }

  getUserRole(){
    if (this.authService.user === undefined || this.authService.user === null) {
      return '';
    }
    return this.authService.user.role;
  }

  canViewSharedSettings(): boolean {
    return ['DDPD', 'DDPC', 'DDPS'].includes(this.getUserRole());
  }

  canViewUserManagement(): boolean {
    return this.getUserRole() === 'DDPD' && !this.deId;
  }

  canViewAnnouncementManagement(): boolean {
    return this.enableNotificationManagement &&
      Boolean(this.getUserRole()) &&
      !this.deId;
  }

  shouldShowSettings(): boolean {
    return (this.canViewSharedSettings() && (
      this.enableItemsOfInterest ||
      this.enabledStockAreaConfig ||
      this.enableConfigurationManagement
    )) || this.canViewUserManagement() || this.canViewAnnouncementManagement();
  }

  updateDeIdMode(value: boolean) {
    if (!this.authService.isDemoUser()) {
      this.deId = value;
      this.authService.deIdentified = value;
    }
  }

  getLogo(){
    if (environment.logoFile){
      return "assets/images/all_logos" + environment.logoFile
    }
    else{
      return "assets/images/all_logos/logo_MAAP-Logon.png"
    }
    
  }
}
